import pluginSlots from "@/_utils/pluginSlots";

let registeredPlugins = [];

try {
  const generated = require("./generated");
  registeredPlugins = generated.default || generated;
} catch (error) {
  registeredPlugins = [];
}

export function loadPlugins(Vue, { router, store, i18n }) {
  registeredPlugins.forEach((plugin) => {
    try {
      Vue.use(plugin, { router, store, i18n, pluginSlots });
    } catch (error) {
      console.warn("Plugin frontend non caricato", error);
    }
  });
}

export { pluginSlots };
